import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';

@Component({
  selector: 'jhi-eappreg-receipt',
  templateUrl: './eappreg-receipt.component.html',
  styleUrls: ['./eappreg-receipt.component.scss']
})
export class EappregReceiptComponent { //implements OnInit {

  eAppRegConstant = BUSINESS_REG_APP_CONSTANT ;
  WEB_EOS_URL="";
  urlWebFilingId = "";
  urlNbr = "" ;
  trcAppForm : any;
  headerstmt = "New Business Registration";
  constructor(private route: ActivatedRoute,
    private businessRegAppService : BussinessRegAppService,
    private router: Router) {
    this.route.queryParams.subscribe(params => {
      this.urlWebFilingId = params['web_filing_id'] ?? "";
      this.urlNbr = params['nbr'] ?? "";
      sessionStorage.setItem("urlNbr",this.urlNbr)
      sessionStorage.setItem("urlWebFilingId",this.urlWebFilingId)
    });
   }

  ngOnInit(): void {
    this.trcAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "") ;
    this.businessRegAppService.getSystemParam("WEB_PAPERLESS_URL").subscribe((res: any) => {
      this.WEB_EOS_URL = res
    })
    this.updateWebLogonData();
  }

  print_page(): void {
    window.print();
  }

  get sessionStorage() : any {
    return sessionStorage ;
  }
  
  updateWebLogonData():void{
    if(sessionStorage.getItem("TaxPayerLogonDataID") !== null){
      this.businessRegAppService.updateWebTaxPayer(sessionStorage.getItem("TaxPayerLogonDataID")?? "",this.router.url.split("?")[0].substring(1)).subscribe();
    }else{
      this.businessRegAppService.updateWebTaxPayerUsingWebFiling(this.urlWebFilingId,this.router.url.split("?")[0].substring(1)).subscribe();
    }
  }
}
